import { useState } from "react";
import { hotDaily, hotWeekly, type RankingItem } from "@/mocks/home";

const tabs = [
  { key: "daily", label: "今日热榜" },
  { key: "weekly", label: "本周热榜" },
];

function trendMeta(trend: RankingItem["trend"]) {
  if (trend === "up") {
    return { icon: "ri-arrow-up-line", className: "text-accent-600", text: "上升" };
  }
  if (trend === "down") {
    return { icon: "ri-arrow-down-line", className: "text-secondary-600", text: "回落" };
  }
  return { icon: "ri-sparkling-line", className: "text-primary-600", text: "新上榜" };
}

export default function HotRanking() {
  const [active, setActive] = useState("daily");
  const list = active === "daily" ? hotDaily : hotWeekly;

  return (
    <section id="hot" className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">
              <i className="ri-bar-chart-box-line w-4 h-4 flex items-center justify-center text-sm" />
              Ranking
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              热度榜 · 哪条最值得先看
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">
              按讨论热度和浏览量排序，越靠前说明越多人正在看、正在聊。
            </p>
          </div>

          <div className="flex shrink-0 rounded-full border border-background-200 bg-background-100 p-1">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActive(tab.key)}
                className={
                  active === tab.key
                    ? "rounded-full bg-primary-500 px-4 py-1.5 text-sm font-semibold text-background-50 transition-colors md:px-5 md:py-2"
                    : "rounded-full px-4 py-1.5 text-sm font-medium text-foreground-600 transition-colors hover:text-primary-600 md:px-5 md:py-2"
                }
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <ol className="mt-8 grid grid-cols-1 gap-3 lg:grid-cols-2 lg:gap-4">
          {list.map((item, index) => {
            const trend = trendMeta(item.trend);
            const isTop = index < 3;
            return (
              <li
                key={item.title}
                className="animate-fade-up group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-100 md:p-5"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <span
                  className={
                    isTop
                      ? "flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50"
                      : "flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-background-200 font-heading text-lg font-bold text-foreground-700"
                  }
                >
                  {item.rank}
                </span>

                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <span className="whitespace-nowrap rounded-sm bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900">
                      {item.category}
                    </span>
                  </div>
                  <h3 className="mt-1.5 truncate font-heading text-sm font-bold text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
                    {item.title}
                  </h3>
                </div>

                <div className="flex shrink-0 flex-col items-end gap-1">
                  <span className="flex items-center gap-1 font-label text-sm font-semibold text-accent-600">
                    <i className="ri-fire-line w-3.5 h-3.5 flex items-center justify-center text-xs" />
                    {item.heat}
                  </span>
                  <span className={`flex items-center gap-0.5 text-[11px] ${trend.className}`}>
                    <i className={`${trend.icon} w-3.5 h-3.5 flex items-center justify-center text-xs`} />
                    {trend.text}
                  </span>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}